import {
    BATCH_SET_UNREAD_COUNTS,
    DECREASE_UNREAD_COUNT,
    GROUP_NOTIFICATION_MSG_COUNT,
    INCREASE_UNREAD_COUNT,
    RESET_UNREAD_COUNT,
    RESET_UNREAD_FOR_USER,
    SET_UNREAD_COUNT,
    UNREAD_MESSAGE_DELETE,
    UNREAD_MESSAGE_UPDATE,
    UNREAD_USER_OBJ,
} from '../Actions/Constants';

const initialState = { id: null, unreadDataObj: {} };
let msgCount = 0;

const updateCount = (unreadDataObj = {}, currentData) => {
    const existUser = unreadDataObj[currentData.fromUserId];
    const currentDataCount = currentData.count;
    if (currentDataCount) {
        msgCount += currentDataCount;
    } else {
        msgCount = msgCount + 1;
    }
    if (!existUser) {
        unreadDataObj[currentData.fromUserId] = {
            count: currentDataCount || 1,
        };
    } else if (currentData.isRefresh) {
        unreadDataObj[currentData.fromUserId] = {
            ...existUser,
            count: currentData.count || existUser.count,
        };
    } else {
        const count = currentDataCount ? currentDataCount + existUser.count : existUser.count;
        unreadDataObj[currentData.fromUserId] = { ...existUser, count: count + 1 };
    }
    return unreadDataObj;
};

const createDefaultUnreadObj = () => ({
    count: 0,
    unreadMsgId: '',
});

const increaseUnreadCount = (data, unreadData = {}) => {
    const { userId, msgId } = data;
    const current = unreadData[userId] || createDefaultUnreadObj();
    const obj = {
        ...current,
        count: current.count + 1,
        unreadMsgId: current.count === 0 ? msgId : current.unreadMsgId,
    };
    return {
        ...unreadData,
        [userId]: obj,
    };
};

const decreaseUnreadCount = (userId, unreadData = {}) => {
    const current = unreadData[userId];
    if (!current || current.count === 0) return unreadData;
    const obj = {
        ...current,
        count: Math.max(0, current.count - 1),
    };
    return {
        ...unreadData,
        [userId]: obj,
    };
};

const setUnreadCount = (userId, count, unreadData = {}) => {
    const current = unreadData[userId] || createDefaultUnreadObj();
    const obj = {
        ...current,
        count: Math.max(0, count),
    };
    return {
        ...unreadData,
        [userId]: obj,
    };
};

const resetUnreadForUser = (userId, unreadData = {}) => {
    const current = unreadData[userId] || createDefaultUnreadObj();
    const obj = {
        ...current,
        count: 0,
    };
    return {
        ...unreadData,
        [userId]: obj,
    };
};

export function UnreadCountReducer(state = initialState, action = {}) {
    const data = action.payload?.data || {};
    const { payload } = action;

    switch (action.type) {
        case UNREAD_MESSAGE_UPDATE:
            return {
                ...state,
                id: payload.id,
                unreadDataObj: updateCount(state.unreadDataObj, payload.data),
            };
        case INCREASE_UNREAD_COUNT:
            return { ...state, unreadDataObj: increaseUnreadCount(data, state.unreadDataObj) };

        case DECREASE_UNREAD_COUNT:
            return { ...state, unreadDataObj: decreaseUnreadCount(data.fromUserId, state.unreadDataObj) };

        case SET_UNREAD_COUNT:
            return { ...state, unreadDataObj: setUnreadCount(data.fromUserId, data.count, state.unreadDataObj) };

        case RESET_UNREAD_FOR_USER:
        case UNREAD_MESSAGE_DELETE: // Legacy action - same as ResetUnreadForUser
            return { ...state, unreadDataObj: resetUnreadForUser(data.fromUserId, state.unreadDataObj) };

        case RESET_UNREAD_COUNT:
            return { ...initialState, unreadDataObj: {} };

        case BATCH_SET_UNREAD_COUNTS:
            const batchUpdates = {};
            for (const userId in data) {
                const unreadData = data[userId];
                const current = state.unreadDataObj?.[userId] || createDefaultUnreadObj();
                batchUpdates[userId] = {
                    ...current,
                    count: unreadData.count,
                    unreadMsgId: unreadData.unreadMsgId,
                };
            }
            return { ...state, unreadDataObj: { ...state.unreadDataObj, ...batchUpdates } };
        default:
            return state;
    }
}

const initialUnreadUserObj = {};

export function UnreadUserObjReducer(state = { ...initialUnreadUserObj }, action = {}) {
    const { type, payload } = action;
    if (type === UNREAD_USER_OBJ) {
        const { fromUserId, count } = payload.data;
        return {
            ...state,
            [fromUserId]: {
                ...state[fromUserId],
                apiOriginalCount: payload.data.apiOriginalCount || state[fromUserId]?.apiOriginalCount || 0,
                fetchDirection: payload.data.fetchDirection || state[fromUserId]?.fetchDirection || 'up',
                unreadRealTimeMsgCount:
                    payload.data.unreadRealTimeMsgCount ?? state[fromUserId]?.unreadRealTimeMsgCount ?? 0,
                count: count,
                includeMsgObj: payload.data.includeMsgObj ?? false,
                fromUserId: fromUserId,
                unreadMsgId: state[fromUserId]?.unreadMsgId || payload.data.unreadMsgId || '',
                fetchLastMsgId: payload.data.fetchLastMsgId ?? state[fromUserId]?.fetchLastMsgId ?? '',
                chatJid: state[fromUserId]?.chatJid || payload.data.chatJid || '',
                fullyViewedChat: payload.data.fullyViewedChat ?? state[fromUserId]?.fullyViewedChat ?? false,
                fullyScrolled: payload.data.fullyScrolled ?? state[fromUserId]?.fullyScrolled ?? false,
                intialChatFetching: payload.data.intialChatFetching || state[fromUserId]?.intialChatFetching || true,
                msgFetchedSet: payload.data.msgFetchedSet || state[fromUserId]?.msgFetchedSet || 0,
            },
        };
    }
    if (type === UNREAD_MESSAGE_DELETE) {
        const fromUserId = payload?.data?.fromUserId;
        if (fromUserId) {
            const chatId = fromUserId.includes('@') ? fromUserId.split('@')[0] : fromUserId;
            const newState = { ...state };
            delete newState[chatId];
            return newState;
        }
    }
    return state;
}

export function groupNotificationMsgCountReducer(state = {}, action = {}) {
    const { type, payload } = action;
    if (type === GROUP_NOTIFICATION_MSG_COUNT) {
        const { fromUserId, setNumber, notificationCount } = payload.data || {};
        return {
            ...state,
            [fromUserId]: {
                ...state[fromUserId],
                [setNumber]: notificationCount || state[fromUserId]?.[setNumber] || 0,
            },
        };
    }
    return state;
}
